import React, { useState, useEffect } from "react";
import { FaSpinner } from "react-icons/fa";
import ReactDatePicker from "react-datepicker";
import { Table } from "react-bootstrap";
import moment from "moment";
import { API_URL } from "../../../constants";
import {
    GetServiceCaller,
    PostFormServiceCaller,
    PostServiceCaller,
} from "../../../services/serviceCaller";
import LeaveSummary from "../Leave/ApplyLeave/LeaveSummary";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { getDay } from "date-fns";
import LeaveHistory from "../Leave/ApplyLeave/LeaveHistory";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { FileUploader } from "../Leave/ApplyLeave/components/MultipleFileUploader";

const VIewSPLeave = () => {
    const navigate = useNavigate();
    const { id } = useParams()
    let today = moment().format("DD-MMM-YYYY");
    const initialFormData = {
        FromDate: moment(new Date()).format("DD-MMM-YYYY"), // Initially empty (user must select)
        ToDate: moment(new Date()).format("DD-MMM-YYYY"), // Initially empty
        EmployeeID: "", // Empty string (or default value if needed)
        // dates: "", // Empty until dates are selected
        Purpose: "", // Empty string
        revisionNumber: "",
        LeaveTypeID: "", // Empty (or auto-generated later)
        rowstatus: 435, // Empty (or default like "0" if required)
        leavesFile: null, // No file selected initially
    };
    const [leaveDetails, setLeaveDetails] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [daysDifference, setDaysDifference] = useState(1);
    const [disabledDatess, setDisabledDatess] = useState([]);
    const [submitted, setSubmit] = useState(false);
    const [displayedDates, setDisplayedDates] = useState([
        moment().format("DD-MMM-YYYY"),
    ]);
    const [errors, setErrors] = useState({});
    const [leaveTypeoptions, setLeaveTypeOptions] = useState([]);
    const [leaveHistory, setLeaveHistory] = useState([]);
    const [lineData, setLineData] = useState([]);
    const [formData, setFormData] = useState(initialFormData);
    console.log("formData",formData);
    
    const [fileName, setFileName] = useState("");
    console.log("fileName",fileName);
    
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [empDetails, SetEmpDetails] = useState([]);
    const [leaveSummaryOptions, setLeaveSummaryOptions] = useState([])
    const [empGender, setEmpGender] = useState()

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading(`View PL/BL/ML/SL Leave`));
        fetchShowApi();
        setFileUrl(null);
        setFile(null);
        setFileName("");
        setFormData(initialFormData);
    }, []);
    const [availableDates, setAvailableDates] = useState('')


    const fetchShowApi = async () => {
        try {

            const response = await GetServiceCaller(`${API_URL}get-special-leaves-details/${id}`)

            if (response?.status === 200) {
                const leaveType = response?.data?.specialLeaveFullList;
                const leaveSummary = response?.data?.leaveSummary;
                const leavehis = response?.data?.leaveHistory;
                const emp_Gender = response?.data?.employeegender?.Gender_020;
                dispatch(updateNavbarHeading(`View PL/BL/ML/SL Leave`));

                setEmpGender(emp_Gender)
                const leaveHeaderData = response?.data?.leaveList;

                const FormEditData = {
                    FromDate: moment(leaveHeaderData?.FromDate).format("DD-MMM-YYYY"),
                    ToDate: moment(leaveHeaderData?.ToDate).format("DD-MMM-YYYY"),
                    leavesFile: leaveHeaderData?.FileName,
                    FilePath: leaveHeaderData?.FilePath,
                    Purpose: leaveHeaderData?.Purpose, // Empty string
                    revisionNumber: "",
                    LeaveTypeID: response?.data?.leaveLine[0]?.LeaveID, // Empty (or auto-generated later)
                    rowstatus: 435, // Empty (or default like "0" if required)
                    leavesFile: leaveHeaderData?.FilePath, // No file selected initially
                }
                setFileName(leaveHeaderData?.FileName);
                setLeaveHistory(leavehis)
                setFormData(FormEditData)
                setLeaveSummaryOptions(leaveSummary)
                setLeaveDetails(leaveType);



                // Filter out the unwanted LeaveID and LeaveType

                const leaveopt = leaveType.map((el) => ({
                    value: el.ID,
                    label: el.Name,
                }));
                setLeaveTypeOptions(leaveopt);
                setPageLoading(false);
            }

        } catch (error) {
            console.error("Error Fetchung Show API ", error);

        }
    }

    useEffect(() => {
        if (formData.FromDate && formData.ToDate) {
            const daysDiff = countWeekdays(
                moment(formData.FromDate, "DD-MMM-YYYY"),
                moment(formData.ToDate, "DD-MMM-YYYY")
            );
            setDaysDifference(daysDiff);
            setDisplayedDates(generateDateRange(formData.FromDate, formData.ToDate));
        }
    }, [formData]);
    useEffect(() => {
        if (formData?.LeaveTypeID) {
            const balanceDates =

                leaveSummaryOptions?.find(el => el.LeaveID == formData?.LeaveTypeID)?.LeaveBalance ??
                leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay

            setAvailableDates(Number(balanceDates))
        }
    }, [formData?.LeaveTypeID])


    const filteredLeaveDetails = leaveDetails.filter((item) =>
        ["ML", "BL", "PL", "Total"].includes(item.Name)
    );

    const countWeekdays = (startDate, endDate) => {
        // If leave type ID is 4, count all days including weekends and holidays
        if (formData.LeaveTypeID === 4) {
            return moment(endDate).diff(moment(startDate), 'days') + 1;
        }

        let count = 0;
        let currentDate = moment(startDate);

        while (currentDate.isSameOrBefore(endDate, "day")) {
            if (isWeekday(currentDate.toDate())) {
                count++;
            }
            currentDate.add(1, "days");
        }
        return count;
    };


    const handleDateChange = (date, field) => {
        const formattedDate = moment(date).format("DD-MMM-YYYY");

        if (field === "FromDate") {
            const newFormData = {
                ...formData,
                FromDate: formattedDate,
            };

            // Handle LeaveTypeID-specific rules
            if (formData.LeaveTypeID === 4 && formData.ToDate) {
                // Type 4: Max 180 days
                const fromDateMoment = moment(formattedDate, "DD-MMM-YYYY");
                const toDateMoment = moment(formData.ToDate, "DD-MMM-YYYY");

                if (toDateMoment.diff(fromDateMoment, 'days') > 180) {
                    newFormData.ToDate = formattedDate;
                }
            } else if (formData.LeaveTypeID === 6) {
                // Type 6: Fixed 2-day range (FromDate + 1 day)
                const defaultDays = Number(leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay - 1) || 1;
                let toDate = moment(formattedDate, "DD-MMM-YYYY");
                let addedDays = 0;

                while (addedDays < defaultDays) {
                    toDate.add(1, "day");
                    if (isWeekday(toDate.toDate())) {
                        addedDays++;
                    }
                }
                newFormData.ToDate = toDate.format("DD-MMM-YYYY");
            } else if (formData.LeaveTypeID === 5) {
                // Type 6: Fixed 2-day range (FromDate + 1 day)
                const defaultDays = Number(leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay - 1) || 1;
                let toDate = moment(formattedDate, "DD-MMM-YYYY");
                let addedDays = 0;

                while (addedDays < defaultDays) {
                    toDate.add(1, "day");
                    if (isWeekday(toDate.toDate())) {
                        addedDays++;
                    }
                }
                newFormData.ToDate = toDate.format("DD-MMM-YYYY");
            } else {
                // Default: ToDate = FromDate
                newFormData.ToDate = formattedDate;
            }

            setFormData(newFormData);
            countWeekdays(newFormData.FromDate, newFormData.ToDate)
            updateDateDisplay(newFormData.FromDate, newFormData.ToDate);

        } else if (field === "ToDate") {
            const fromDateMoment = moment(formData.FromDate, "DD-MMM-YYYY");
            const toDateMoment = moment(formattedDate, "DD-MMM-YYYY");

            // Validation rules
            if (formData.LeaveTypeID === 4) {
                // Type 4: Max 180 days
                if (toDateMoment.diff(fromDateMoment, 'days') > 180) {
                    toast.error("Leave duration cannot exceed 180 days for this leave type!");
                    return;
                }
            } else if (formData.LeaveTypeID === 6) {
                // Type 6: Exactly 2-day range
                const expectedToDate = moment(formData.FromDate, "DD-MMM-YYYY")
                    .add(Number(leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay) - 1, 'days')
                    .format("DD-MMM-YYYY");

                if (formattedDate !== expectedToDate) {
                    toast.error(`For this leave type, To Date must be exactly ${expectedToDate}`);
                    return;
                }
            } else if (formData.LeaveTypeID === 5) {
                // Type 5: Exactly 2-day range
                const expectedToDate = moment(formData.FromDate, "DD-MMM-YYYY")
                    .add(Number(leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay) - 1, 'days')
                    .format("DD-MMM-YYYY");

                if (formattedDate !== expectedToDate) {
                    toast.error(`For this leave type, To Date must be exactly ${expectedToDate}`);
                    return;
                }
            } else {
                // Default: ToDate cannot be before FromDate
                if (toDateMoment.isBefore(fromDateMoment, "day")) {
                    toast.error("To Date cannot be before From Date!");
                    return;
                }
            }

            setFormData({ ...formData, [field]: formattedDate });
            updateDateDisplay(formData.FromDate, formattedDate);
        }
    };

    // Helper function to avoid code duplication
    const updateDateDisplay = (fromDate, toDate) => {
        const fromMoment = moment(fromDate, "DD-MMM-YYYY");
        const toMoment = moment(toDate, "DD-MMM-YYYY");
        setDaysDifference(countWeekdays(fromMoment, toMoment));
        setDisplayedDates(generateDateRange(fromDate, toMoment));
    };
    const generateDateRange = (fromDate, toDate) => {
        // If leave type ID is 4, include all dates
        if (formData.LeaveTypeID === 4) {
            let currentDate = moment(fromDate, "DD-MMM-YYYY");
            const endDate = moment(toDate, "DD-MMM-YYYY");
            let dates = [];

            while (currentDate.isSameOrBefore(endDate, "day")) {
                dates.push(currentDate.format("DD-MMM-YYYY"));
                currentDate.add(1, "days");
            }
            return dates;
        }

        // Original logic for other leave types
        let currentDate = moment(fromDate, "DD-MMM-YYYY");
        const endDate = moment(toDate, "DD-MMM-YYYY");
        let dates = [];

        while (currentDate.isSameOrBefore(endDate, "day")) {
            if (isWeekday(currentDate.toDate())) {
                dates.push(currentDate.format("DD-MMM-YYYY"));
            }
            currentDate.add(1, "days");
        }

        return dates;
    };

    const isWeekday = (date) => {
        // If leave type ID is 4, allow all dates (including holidays and weekends)
        if (formData.LeaveTypeID === 4) {
            return true;
        }

        const day = moment(date).isoWeekday(); // 6 = Saturday, 7 = Sunday

        const today = moment();
        const firstDayOfCurrentMonth = today.startOf("month");
        const lastDayOfPrevMonth = firstDayOfCurrentMonth
            .clone()
            .subtract(1, "day");
        const firstDayOfPrevMonth = lastDayOfPrevMonth.clone().startOf("month");

        // Check if the date is in the previous month
        const isPrevMonth = moment(date).isBetween(
            firstDayOfPrevMonth,
            lastDayOfPrevMonth,
            "day",
            "[]" // Inclusive
        );

        const isWeekend = day === 6 || day === 7;
        const isHoliday = disabledDatess.some((disabledDate) =>
            moment(disabledDate, "DD-MMM-YYYY").isSame(moment(date), "day")
        );

        return !isWeekend && !isHoliday && !isPrevMonth;
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });

        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };
    const validateForm = () => {
        const newErrors = {};

        if (!formData.Purpose?.trim()) {
            newErrors.Purpose = "Purpose is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const handleEdit = (id) => {
        navigate(`/special-leave/edit/${id}`, { state: { disabledDatess } });
    };

    let remainingCOff =
        filteredLeaveDetails.find((leave) => leave.Name === "C-Off")
            ?.LeaveBalance || 0;
    let remainingEL =
        filteredLeaveDetails.find((leave) => leave.Name === "EL")
            ?.LeaveBalance || 0;

    const handleFile = (files) => {
        if (files) {
            const selectedFile = files;

            // Create object URL
            const url = URL.createObjectURL(selectedFile);
            setFileUrl(url); // Store the URL

            // Clear any previous error messages
            setErrors((prevErrors) => ({
                ...prevErrors,
                leavesFile: "",
            }));

            setFile(selectedFile);
            setFileName(selectedFile.name);

            setFormData((prevState) => ({
                ...prevState,
                leavesFile: selectedFile,
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                leavesFile:
                    "File size should not exceed 1MB and must be a PDF or Word document.",
            }));
        }
    };

    // Don't forget to revoke the object URL when component unmounts
    useEffect(() => {
        return () => {
            if (fileUrl) {
                URL.revokeObjectURL(fileUrl);
            }
        };
    }, [fileUrl]);


    const handleSelectChange = async (value) => {
        setFormData({
            ...formData, LeaveTypeID: value, FromDate: moment(new Date()).format("DD-MMM-YYYY"), // Initially empty (user must select)
            ToDate: moment(new Date()).format("DD-MMM-YYYY"),
        });

        // Recalculate days difference when leave type changes
        const fromDateMoment = moment(formData.FromDate, "DD-MMM-YYYY");
        const toDateMoment = moment(formData.ToDate, "DD-MMM-YYYY");
        const daysDiff = countWeekdays(fromDateMoment, toDateMoment);
        setDaysDifference(1);

        setDisplayedDates(generateDateRange(formData.FromDate, formData.ToDate));
    }


    if (pageLoading) {
        return (
            <>
                <p class="position-absolute top-50 start-50 translate-middle text-center">
                    <FaSpinner class="spinner" />
                </p>
            </>
        );
    } else {
        return (
            <>
                <div className="container-fluid">
                    <div className="row gx-lg-1">
                        <div className="col-12 col-lg-7 pe-1">
                            <div className="container-fluid" id="skill-table-area">
                                <form className="p-2">

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label for="leave-type" class="form-label">
                                                Leave Type<span className="required">*</span>
                                            </label>
                                            <Select
                                                isDisabled={true}
                                                value={leaveTypeoptions?.find(el => el.value == formData?.LeaveTypeID)}
                                                options={leaveTypeoptions}
                                                onChange={(selectedOptions) => handleSelectChange(selectedOptions.value)}
                                            />

                                        </div>
                                        <div className="col-sm-6">
                                            <label for="leave-type" class="form-label">
                                                Employee<span className="required">*</span>
                                            </label>
                                            <input  disabled  className="form-control" value={leaveHistory[0]?.EmployeeName || ""}/>

                                        </div>


                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-sm-12">
                                            <label for="leave-type" class="form-label">
                                                Purpose<span className="required">*</span>
                                            </label>
                                            <textarea
                                                type="text"
                                                className={`form-control ${errors.Purpose ? "is-invalid" : ""
                                                    }`}
                                                id="Purpose"
                                                disabled
                                                aria-describedby="Purpose"
                                                name="Purpose"
                                                value={formData.Purpose}
                                                onChange={handleInputChange}
                                            />
                                            {errors.Purpose && (
                                                <div className="invalid-feedback">{errors.Purpose}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row mt-2">

                                        <div className="col-sm-4">
                                            <label htmlFor="TargetDate" className="form-label">
                                                From Date<span className="required">*</span>
                                            </label>
                                            <ReactDatePicker
                                                autoComplete="off"
                                                changeYear
                                                changeMonth
                                                showPopperArrow
                                                disabled
                                                showIcon
                                                icon="fa fa-calendar"
                                                className="form-control"
                                                format="d-MM-YYYY"
                                                name="FromDate"
                                                id="FromDate"
                                                filterDate={isWeekday}
                                                onChange={(date) => handleDateChange(date, "FromDate")}
                                                selected={
                                                    formData.FromDate
                                                        ? moment(formData.FromDate, "DD-MMM-YYYY").toDate()
                                                        : null
                                                }
                                                dateFormat="dd-MMM-yyyy"
                                                minDate={moment()
                                                    .subtract(2, "month")
                                                    .startOf("month")
                                                    .toDate()}
                                                maxDate={moment()
                                                    .add(1, "months")
                                                    .endOf("month")
                                                    .toDate()}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <label htmlFor="TargetDate" className="form-label">
                                                To Date<span className="required">*</span>
                                            </label>

                                            <ReactDatePicker
                                                autoComplete="off"
                                                // minDate={new Date()}
                                                changeYear
                                                disabled
                                                changeMonth
                                                showPopperArrow
                                                showIcon
                                                icon="fa fa-calendar"
                                                className="form-control"
                                                format="d-MM-YYYY"
                                                name="ToDate"
                                                id="ToDate"
                                                filterDate={isWeekday}
                                                onChange={(date) => handleDateChange(date, "ToDate")}
                                                selected={
                                                    formData.ToDate
                                                        ? moment(formData.ToDate, "DD-MMM-YYYY").toDate()
                                                        : null
                                                }
                                                dateFormat="dd-MMM-yyyy"
                                                minDate={
                                                    formData.FromDate
                                                        ? moment(formData.FromDate, "DD-MMM-YYYY").toDate()
                                                        : moment()
                                                            .subtract(2, "month")
                                                            .startOf("month")
                                                            .toDate()
                                                }
                                                maxDate={
                                                    formData.FromDate && availableDates
                                                        ? moment(formData.FromDate, "DD-MMM-YYYY")
                                                            .add(availableDates - 1, "days")
                                                            .toDate()
                                                        : moment()
                                                            .add(1, "months")
                                                            .endOf("month")
                                                            .toDate()
                                                }

                                            />
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div class="mb-3">
                                                <label for="days" class="form-label">
                                                    No. of Days
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control text-end"
                                                    id="days"
                                                    aria-describedby="days"
                                                    name="days"
                                                    value={daysDifference}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <div className="col-md-4">
                                                {/* <FileUploader
                                                    handleFile={handleFile}
                                                    accept=".pdf,.doc,.docx" // Specify accepted file types
                                                /> */}
                                            </div>
                                            {fileName && (
                                                <div className="mt-2">
                                                     File:{" "}
                                                    <a
                                                        href={formData?.FilePath || fileUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {fileName}
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <button type="button" className="cancel-btn" onClick={() => navigate(`/approve/special-leave`)}>
                                            Cancel                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 pe-1">
                            <LeaveSummary leaveDetails={leaveSummaryOptions} />
                            <LeaveHistory
                                leaveHistory={leaveHistory}
                                onEdit={handleEdit}
                                showAction={false}
                                title="Leave History"
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default VIewSPLeave;
